import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Workspace } from 'types'
import { UserService } from 'api/clients/UserService'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Button } from 'components/Button/Button'
import { WorkspaceService } from 'api/services/WorkspaceService'
import Styles from './NotFound.module.scss'
import { HOME_PATH } from 'paths'

export const NotFound = () => {
  const history = useHistory()
  const [disabled, setDisabled] = useState(false)
  const workspaceId = useCurrentWorkspaceId()

  const pushToHome = async () => {
    setDisabled(true)
    const {
      data: { workspaces },
    } = await WorkspaceService.getWorkspaces()

    const validWorkspace = (workspaces as Workspace[]).find((w) => w.id === workspaceId)

    if (!validWorkspace) {
      UserService.setCurrentWorkspaceId(ALMANAC_CORE_WORKSPACE_ID)
    }

    setDisabled(false)
    history.push(HOME_PATH)
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.mainCard}>
        <div className={Styles.header}>
          <div className={Styles.emoji}>
            <span role="img" aria-label="Thinking face emoji">
              🤔
            </span>
          </div>
          <div className={Styles.errorPill}>Error 404</div>
        </div>
        <h1>Hmm... looks like we’re lost.</h1>
        <p>After all, we live on a speck of dust floating in space. Anyways, let’s get back to work. </p>
        <footer>
          <Button size="lg" onPress={pushToHome} isDisabled={disabled}>
            Go Back
          </Button>
        </footer>
      </div>
    </div>
  )
}
